import { Component, HostBinding, Inject, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { EntityFormField, PlanningFormData } from '../../../../services/entity-type.service';
import { PARTIAL_DATA } from '../partialInjectorToken';

@Component({
    selector: 'app-input',
    standalone: false,
    templateUrl: './input.component.html',
    styleUrl: './input.component.scss',
})
export class InputComponent implements OnDestroy {
    @HostBinding('class.field-table-style') tableStyle = false;

    field: EntityFormField;
    formData?: PlanningFormData;
    fc: FormControl;

    protected subscriptions = new Subscription();

    hideMatHint = false;

    constructor(
        @Inject(PARTIAL_DATA)
        componentData?: {
            field: EntityFormField;
            formData: PlanningFormData;
            tableStyle: boolean;
            hideMatHint: boolean;
        }
    ) {
        this.tableStyle = componentData.tableStyle;
        this.field = componentData.field;
        this.fc = componentData.field.fc;
        this.formData = componentData.formData;
        this.hideMatHint = componentData.hideMatHint ?? false;
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
